// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"FileTooltip_tooltipContainer__hbE-H","tooltipContent":"FileTooltip_tooltipContent__vETKO"};